import React from 'react';
import { useFormContext } from 'react-hook-form';
import ClientForm from '../../booking/steps/ClientForm';

/**
 * Formulário de cliente estendido para administradores
 * Adiciona campos específicos de admin (confirmação, pagamento)
 */
const AdminClientForm = (props) => {
  const { register, formState: { errors } } = useFormContext();
  
  return (
    <div className="space-y-6">
      <ClientForm {...props} isAdmin={true} />
      
      {/* Campos adicionais de admin */}
      <div className="bg-white p-4 rounded-lg shadow-sm mt-4">
        <h3 className="text-lg font-medium mb-3">Opções Administrativas</h3>
        
        <div className="space-y-3">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="confirmed"
              className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              {...register("confirmed")}
            />
            <div className="ml-2">
              <label htmlFor="confirmed" className="block text-sm text-gray-700">
                Cliente confirmou presença
              </label>
              <p className="text-xs text-gray-500 mt-0.5">
                Indica que o cliente foi contatado e confirmou que comparecerá ao agendamento
              </p>
            </div>
          </div>
          
          <div className="flex items-center">
            <input
              type="checkbox"
              id="paymentConfirmed"
              className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              {...register("paymentConfirmed")}
            />
            <div className="ml-2">
              <label htmlFor="paymentConfirmed" className="block text-sm text-gray-700">
                Pagamento confirmado
              </label>
              <p className="text-xs text-gray-500 mt-0.5">
                Cliente já realizou o pagamento antecipado do serviço
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminClientForm; 